module.exports = __webpack_public_path__ + "img/black-arrow-right.b7102d36.svg";